!(function (t, e) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define([], e)
    : "object" == typeof exports
    ? (exports.AudioEngine = e())
    : (t.AudioEngine = e());
})(this, function () {
  return (() => {
    "use strict";
    var t = {
        d: (e, i) => {
          for (var o in i)
            t.o(i, o) &&
              !t.o(e, o) &&
              Object.defineProperty(e, o, { enumerable: !0, get: i[o] });
        },
        o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
        r: (t) => {
          "undefined" != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
            Object.defineProperty(t, "__esModule", { value: !0 });
        },
      },
      e = {};
    t.r(e), t.d(e, { default: () => l });
    var i = (function () {
        function t(t) {
          this.worker = new Worker(t);
        }
        return (
          (t.prototype.setup = function (t, e) {
            console.log("audio decoder setup called");
            for (var i = this, o = [], a = 0; a < e.length; ++a)
              o.push(e[a].data);
            return new Promise(function (a, n) {
              (i.worker.onmessage = function (t) {
                if (0 !== t.data.status)
                  return (
                    console.log("audio decoder failed to set up"),
                    console.log(t),
                    void n(t.data)
                  );
                console.log("audio decoder setup ok"), a(t.data);
              }),
                i.worker.postMessage({ config: t, packets: e }, o);
            });
          }),
          (t.prototype.decode = function (t) {
            var e = this;
            return new Promise(function (i, o) {
              (e.worker.onmessage = function (t) {
                0 === t.data.status ? i(t.data) : o(t.data);
              }),
                e.worker.postMessage(t, [t.data]);
            });
          }),
          t
        );
      })(),
      o = (function () {
        function t(t) {
          this.worker = new Worker(t);
        }
        return (
          (t.prototype.setup = function (t) {
            var e = this;
            return new Promise(function (i, o) {
              (e.worker.onmessage = function (t) {
                if (0 !== t.data.status) return console.log(t), void o(t.data);
                console.log("audio encoder setup ok"), i(t.data.packets);
              }),
                e.worker.postMessage(t);
            });
          }),
          (t.prototype.encode = function (t) {
            var e = this;
            return new Promise(function (i, o) {
              (e.worker.onmessage = function (t) {
                0 === t.data.status ? i(t.data.packets) : o(t.data);
              }),
                e.worker.postMessage(t);
            });
          }),
          t
        );
      })(),
      a = (function () {
        function t(t, e, i) {
          var o = this;
          (this.mode = "HEART"),
            (this.drawOnScreen = function () {
              (o.canvasContextXX.imageSmoothingEnabled = !1),
                o.canvasContextXX.drawImage(o.wf.offScreenCvs, 0, 0),
                o.playing && requestAnimationFrame(o.drawOnScreen);
            }),
            (this.divID = e),
            (this.mode = i ? "HEART" : "LUNG"),
            (this.context = t),
            (this.analyserNode = this.context.createAnalyser()),
            (this.analyserNode.fftSize = 2048),
            (this.analyserNode.smoothingTimeConstant = 0),
            (this.frqBuf = new Uint8Array(this.analyserNode.frequencyBinCount)),
            (this.floatFreqData = new Float32Array(
              this.analyserNode.frequencyBinCount
            )),
            (this.floatTimeData = new Float32Array(
              this.analyserNode.frequencyBinCount
            )),
            (this.wfNumPts = 400),
            (this.wfBufAry = [this.frqBuf]),
            console.log(e),
            console.log(document.getElementById(e)),
            (this.canvas = document.getElementById(e));
          var a = this.canvas.getBoundingClientRect();
          (this.targetWidth = Math.floor(a.width)),
            (this.targetHeight = Math.floor(a.height)),
            (this.wf = new n(
              this.wfBufAry,
              this.targetWidth,
              this.targetHeight,
              {},
              this,
              i
            )),
            (this.desiredMaxDB = 0),
            (this.gain = 1),
            (this.canvasContextXX = this.canvas.getContext("2d")),
            this.canvasContextXX.resetTransform();
        }
        return (
          (t.prototype.doGainAdjust = function () {
            for (
              var t = -100, e = 0, i = 0;
              i < this.floatFreqData.length / 30;
              i++
            )
              this.floatFreqData[i] > t && (t = this.floatFreqData[i]),
                this.floatFreqData[i] < e && (e = this.floatFreqData[i]);
            var o = this.desiredMaxDB - t;
            this.gain = 0.985 * this.gain + 0.015 * o;
          }),
          (t.prototype.convertToByteFrequencyData = function () {
            for (
              var t = 12 / this.floatFreqData.length, e = 0;
              e < this.floatFreqData.length;
              e++
            ) {
              var i = this.floatFreqData[e] + this.gain,
                o = 400 * Math.pow(10, 0.05 * i) * (1 + t * e) - 10;
              o > 255 && (o = 255), o < 0 && (o = 0), (this.frqBuf[e] = o);
            }
          }),
          (t.prototype.getCursorPosition = function () {
            this.analyserNode.getFloatTimeDomainData(this.floatTimeData);
            for (var t = 0, e = 0; e < this.floatTimeData.length / 2; e++)
              t += this.floatTimeData[e];
            return t / this.floatTimeData.length / 2;
          }),
          (t.prototype.getMaxMinPosition = function () {
            this.analyserNode.getFloatTimeDomainData(this.floatTimeData);
            for (
              var t = -1, e = 1, i = 0;
              i < this.floatTimeData.length / 2;
              i++
            ) {
              var o = this.floatTimeData[i];
              o > t && (t = o), o < e && (e = o);
            }
            return [t, e];
          }),
          (t.prototype.adjustVerticalScaleByteBuffer = function () {
            for (var t = this.frqBuf.length; t > 1; t--) {
              var e = t / 2,
                i = Math.round(e - 1),
                o = Math.round(e),
                a = Math.round(e + 1);
              this.frqBuf[t] =
                0.25 * this.frqBuf[i] +
                0.5 * this.frqBuf[o] +
                0.25 * this.frqBuf[a];
            }
          }),
          (t.prototype.beginDisplay = function () {
            this.wf.start(), (this.playing = !0), this.drawOnScreen();
          }),
          (t.prototype.haltDisplay = function () {
            this.wf.pause(), (this.playing = !1);
          }),
          (t.prototype.stopDisplay = function () {
            this.wf.stop(), (this.playing = !1);
          }),
          (t.prototype.resumeDisplay = function () {
            this.wf.resume(), (this.playing = !0), this.drawOnScreen();
          }),
          (t.prototype.alterPlayBackSpeed = function (t) {
            this.wf.sgSetLineRate(t);
          }),
          t
        );
      })(),
      n = (function () {
        function t(t, e, i, o, a, n) {
          (this.mode = "HEART"),
            (this.heartMode = n),
            (this.mode = n ? "HEART" : "LUNG"),
            (this.opt = "object" == typeof o ? o : {}),
            (this.ipBufAry = t),
            this.offScreenCtx,
            (this.pxPerLine = e || 200),
            (this.lines = i >= 200 ? i : 200),
            (this.lineRate = 30),
            (this.interval = 0),
            (this.startOfs = 0),
            (this.spectogramDrawer = a),
            (this.vertLineBuf = new ArrayBuffer(4 * parseInt("" + this.lines))),
            (this.vertLineBuf8 = new Uint8ClampedArray(this.vertLineBuf)),
            (this.vertLineImgData = new ImageData(
              this.vertLineBuf8,
              1,
              parseInt("" + this.lines)
            )),
            (this.ipBuf8 = null),
            (this.clearBuf = new ArrayBuffer(
              parseInt("" + this.pxPerLine) * parseInt("" + this.lines) * 4
            )),
            (this.clearBuf8 = new Uint8ClampedArray(this.clearBuf)),
            this.buildColourMap();
          for (var r = 0; r < this.pxPerLine * this.lines * 4; r += 4)
            (this.clearBuf8[r] = this.colMap[0][0]),
              (this.clearBuf8[r + 1] = this.colMap[0][1]),
              (this.clearBuf8[r + 2] = this.colMap[0][2]),
              (this.clearBuf8[r + 3] = this.colMap[0][3]);
          for (var s in (this.clearImgData,
          (this.nextLine = 0),
          (this.timerID = null),
          (this.running = !1),
          (this.sgTime = 0),
          (this.sgStartTime = 0),
          (this.demoCvsId = ""),
          this.opt))
            this.opt.hasOwnProperty(s) && this.setProperty(s, this.opt[s]);
          (this.offScreenCvs = document.createElement("canvas")),
            this.offScreenCvs.setAttribute("height", this.lines.toString()),
            this.offScreenCvs.setAttribute("width", this.pxPerLine.toString()),
            (this.clearImgData = new ImageData(
              this.clearBuf8,
              parseInt("" + this.pxPerLine),
              parseInt("" + this.lines)
            )),
            (this.offScreenCtx = this.offScreenCvs.getContext("2d")),
            (this.offScreenCtx.imageSmoothingEnabled = !1),
            (this.offScreenCtx.strokeStyle = "rgba(255, 255, 255, 1.0)"),
            (this.offScreenCtx.lineWidth = 0.5),
            "string" == typeof this.demoCvsId &&
              this.demoCvsId &&
              document
                .getElementById(this.demoCvsId)
                .appendChild(this.offScreenCvs),
            this.stop();
        }
        return (
          (t.prototype.buildColourMap = function () {
            var t = this.mode;
            (!t && this.heartMode) || "HEART" === t
              ? (this.colMap = [
                  [0, 0, 0, 255],
                  [204, 204, 204, 0],
                  [177, 152, 204, 1],
                  [171, 143, 204, 3],
                  [166, 136, 204, 4],
                  [162, 131, 204, 6],
                  [159, 127, 204, 7],
                  [155, 124, 204, 9],
                  [152, 120, 204, 10],
                  [148, 118, 204, 12],
                  [145, 115, 204, 14],
                  [142, 113, 204, 15],
                  [139, 111, 204, 17],
                  [136, 108, 204, 18],
                  [133, 107, 204, 20],
                  [130, 105, 204, 21],
                  [127, 103, 204, 23],
                  [124, 101, 204, 25],
                  [121, 100, 204, 26],
                  [118, 98, 204, 28],
                  [114, 97, 204, 29],
                  [111, 96, 204, 31],
                  [108, 94, 204, 32],
                  [105, 93, 204, 34],
                  [102, 92, 204, 36],
                  [99, 91, 204, 37],
                  [96, 89, 204, 39],
                  [93, 88, 204, 40],
                  [90, 87, 204, 42],
                  [87, 86, 204, 43],
                  [85, 86, 204, 45],
                  [84, 88, 204, 46],
                  [83, 89, 204, 48],
                  [82, 90, 204, 49],
                  [81, 91, 204, 51],
                  [80, 93, 204, 53],
                  [79, 94, 204, 54],
                  [78, 95, 204, 56],
                  [78, 97, 204, 57],
                  [77, 98, 204, 59],
                  [76, 100, 204, 60],
                  [75, 102, 204, 62],
                  [74, 103, 204, 63],
                  [74, 105, 204, 65],
                  [73, 107, 204, 66],
                  [72, 108, 204, 68],
                  [71, 110, 204, 69],
                  [71, 112, 204, 71],
                  [70, 114, 204, 72],
                  [69, 116, 204, 74],
                  [68, 118, 204, 75],
                  [68, 120, 204, 77],
                  [67, 122, 204, 78],
                  [66, 124, 204, 80],
                  [66, 126, 204, 81],
                  [65, 128, 204, 83],
                  [64, 130, 204, 84],
                  [64, 132, 204, 86],
                  [63, 134, 204, 87],
                  [63, 136, 204, 89],
                  [62, 139, 204, 90],
                  [61, 141, 204, 92],
                  [61, 143, 204, 93],
                  [60, 145, 204, 95],
                  [60, 148, 204, 96],
                  [59, 150, 204, 97],
                  [59, 152, 204, 99],
                  [58, 155, 204, 100],
                  [57, 157, 204, 102],
                  [57, 160, 204, 103],
                  [56, 162, 204, 105],
                  [56, 164, 204, 106],
                  [55, 167, 204, 108],
                  [55, 169, 204, 109],
                  [54, 172, 204, 110],
                  [54, 174, 204, 112],
                  [53, 177, 204, 113],
                  [53, 180, 204, 115],
                  [52, 182, 204, 116],
                  [52, 185, 204, 117],
                  [51, 187, 204, 119],
                  [51, 190, 204, 120],
                  [50, 193, 204, 122],
                  [50, 195, 204, 123],
                  [49, 198, 204, 124],
                  [49, 201, 204, 126],
                  [48, 204, 204, 127],
                  [48, 204, 201, 128],
                  [48, 204, 198, 130],
                  [47, 204, 195, 131],
                  [47, 204, 192, 132],
                  [46, 204, 190, 134],
                  [46, 204, 187, 135],
                  [45, 204, 184, 136],
                  [45, 204, 181, 138],
                  [45, 204, 178, 139],
                  [44, 204, 175, 140],
                  [44, 204, 172, 142],
                  [43, 204, 170, 143],
                  [43, 204, 167, 144],
                  [42, 204, 164, 146],
                  [42, 204, 161, 147],
                  [42, 204, 158, 148],
                  [41, 204, 155, 149],
                  [41, 204, 152, 151],
                  [40, 204, 149, 152],
                  [40, 204, 146, 153],
                  [40, 204, 143, 154],
                  [39, 204, 140, 156],
                  [39, 204, 137, 157],
                  [39, 204, 134, 158],
                  [38, 204, 131, 159],
                  [38, 204, 127, 161],
                  [37, 204, 124, 162],
                  [37, 204, 121, 163],
                  [37, 204, 118, 164],
                  [36, 204, 115, 165],
                  [36, 204, 112, 167],
                  [36, 204, 109, 168],
                  [35, 204, 106, 169],
                  [35, 204, 102, 170],
                  [35, 204, 99, 171],
                  [34, 204, 96, 172],
                  [34, 204, 93, 174],
                  [33, 204, 89, 175],
                  [33, 204, 86, 176],
                  [33, 204, 83, 177],
                  [32, 204, 80, 178],
                  [32, 204, 76, 179],
                  [32, 204, 73, 180],
                  [31, 204, 70, 181],
                  [31, 204, 67, 183],
                  [31, 204, 63, 184],
                  [30, 204, 60, 185],
                  [30, 204, 57, 186],
                  [30, 204, 53, 187],
                  [29, 204, 50, 188],
                  [29, 204, 47, 189],
                  [29, 204, 43, 190],
                  [29, 204, 40, 191],
                  [28, 204, 36, 192],
                  [28, 204, 33, 193],
                  [28, 204, 30, 194],
                  [28, 204, 27, 195],
                  [31, 204, 27, 196],
                  [34, 204, 27, 197],
                  [37, 204, 26, 198],
                  [40, 204, 26, 199],
                  [42, 204, 26, 200],
                  [45, 204, 25, 201],
                  [48, 204, 25, 202],
                  [51, 204, 25, 203],
                  [54, 204, 25, 204],
                  [57, 204, 24, 205],
                  [60, 204, 24, 206],
                  [63, 204, 24, 207],
                  [66, 204, 23, 208],
                  [69, 204, 23, 209],
                  [72, 204, 23, 209],
                  [75, 204, 23, 210],
                  [78, 204, 22, 211],
                  [81, 204, 22, 212],
                  [84, 204, 22, 213],
                  [87, 204, 21, 214],
                  [90, 204, 21, 215],
                  [93, 204, 21, 215],
                  [96, 204, 21, 216],
                  [99, 204, 20, 217],
                  [102, 204, 20, 218],
                  [105, 204, 20, 219],
                  [108, 204, 19, 220],
                  [111, 204, 19, 220],
                  [114, 204, 19, 221],
                  [118, 204, 19, 222],
                  [121, 204, 18, 223],
                  [124, 204, 18, 223],
                  [127, 204, 18, 224],
                  [130, 204, 18, 225],
                  [133, 204, 17, 226],
                  [137, 204, 17, 226],
                  [140, 204, 17, 227],
                  [143, 204, 17, 228],
                  [146, 204, 16, 228],
                  [149, 204, 16, 229],
                  [153, 204, 16, 230],
                  [156, 204, 15, 230],
                  [159, 204, 15, 231],
                  [162, 204, 15, 232],
                  [166, 204, 15, 232],
                  [169, 204, 14, 233],
                  [172, 204, 14, 234],
                  [176, 204, 14, 234],
                  [179, 204, 14, 235],
                  [182, 204, 13, 236],
                  [186, 204, 13, 236],
                  [189, 204, 13, 237],
                  [192, 204, 13, 237],
                  [196, 204, 12, 238],
                  [199, 204, 12, 238],
                  [202, 204, 12, 239],
                  [204, 201, 12, 239],
                  [204, 198, 12, 240],
                  [204, 194, 11, 241],
                  [204, 191, 11, 241],
                  [204, 188, 11, 242],
                  [204, 184, 11, 242],
                  [204, 181, 10, 243],
                  [204, 177, 10, 243],
                  [204, 174, 10, 243],
                  [204, 170, 10, 244],
                  [204, 167, 9, 244],
                  [204, 163, 9, 245],
                  [204, 160, 9, 245],
                  [204, 157, 9, 246],
                  [204, 153, 8, 246],
                  [204, 150, 8, 246],
                  [204, 146, 8, 247],
                  [204, 142, 8, 247],
                  [204, 139, 8, 248],
                  [204, 135, 7, 248],
                  [204, 132, 7, 248],
                  [204, 128, 7, 249],
                  [204, 125, 7, 249],
                  [204, 121, 6, 249],
                  [204, 118, 6, 250],
                  [204, 114, 6, 250],
                  [204, 110, 6, 250],
                  [204, 107, 6, 250],
                  [204, 103, 5, 251],
                  [204, 100, 5, 251],
                  [204, 96, 5, 251],
                  [204, 92, 5, 251],
                  [204, 89, 4, 252],
                  [204, 85, 4, 252],
                  [204, 81, 4, 252],
                  [204, 78, 4, 252],
                  [204, 74, 4, 253],
                  [204, 70, 3, 253],
                  [204, 67, 3, 253],
                  [204, 63, 3, 253],
                  [204, 59, 3, 253],
                  [204, 56, 3, 253],
                  [204, 52, 2, 254],
                  [204, 48, 2, 254],
                  [204, 45, 2, 254],
                  [204, 41, 2, 254],
                  [204, 37, 2, 254],
                  [204, 33, 1, 254],
                  [204, 30, 1, 254],
                  [204, 26, 1, 254],
                  [204, 22, 1, 254],
                  [204, 18, 1, 254],
                  [204, 15, 0, 254],
                  [204, 11, 0, 254],
                  [204, 7, 0, 254],
                  [204, 3, 0, 254],
                  [204, 0, 0, 255],
                ])
              : (this.colMap = [
                  [0, 0, 0, 255],
                  [255, 255, 255, 0],
                  [221, 191, 255, 3],
                  [214, 179, 255, 6],
                  [208, 171, 255, 9],
                  [203, 164, 255, 11],
                  [198, 159, 254, 14],
                  [194, 155, 254, 16],
                  [190, 151, 254, 18],
                  [186, 147, 254, 21],
                  [182, 144, 254, 23],
                  [178, 141, 254, 25],
                  [174, 138, 254, 27],
                  [170, 136, 254, 29],
                  [166, 133, 254, 31],
                  [162, 131, 254, 33],
                  [158, 129, 254, 35],
                  [155, 127, 254, 37],
                  [151, 125, 254, 39],
                  [147, 123, 254, 41],
                  [143, 121, 254, 43],
                  [139, 120, 254, 45],
                  [136, 118, 254, 47],
                  [132, 116, 254, 49],
                  [128, 115, 254, 51],
                  [124, 113, 254, 53],
                  [120, 112, 254, 55],
                  [116, 110, 254, 57],
                  [112, 109, 254, 58],
                  [109, 108, 254, 60],
                  [106, 108, 254, 62],
                  [105, 110, 254, 64],
                  [104, 111, 254, 66],
                  [103, 113, 254, 67],
                  [102, 114, 254, 69],
                  [100, 116, 254, 71],
                  [99, 118, 254, 73],
                  [98, 119, 254, 74],
                  [97, 121, 254, 76],
                  [96, 123, 254, 78],
                  [95, 125, 254, 79],
                  [94, 127, 254, 81],
                  [93, 129, 254, 83],
                  [92, 131, 254, 84],
                  [91, 133, 254, 86],
                  [90, 136, 254, 88],
                  [89, 138, 254, 89],
                  [88, 140, 254, 91],
                  [87, 142, 254, 92],
                  [87, 145, 254, 94],
                  [86, 147, 254, 96],
                  [85, 150, 254, 97],
                  [84, 152, 254, 99],
                  [83, 155, 254, 100],
                  [82, 157, 254, 102],
                  [81, 160, 254, 103],
                  [81, 162, 254, 105],
                  [80, 165, 254, 107],
                  [79, 168, 254, 108],
                  [78, 170, 254, 110],
                  [78, 173, 254, 111],
                  [77, 176, 254, 113],
                  [76, 179, 254, 114],
                  [75, 182, 254, 115],
                  [75, 185, 254, 117],
                  [74, 187, 254, 118],
                  [73, 190, 254, 120],
                  [73, 193, 254, 121],
                  [72, 196, 254, 123],
                  [71, 199, 254, 124],
                  [70, 202, 254, 126],
                  [70, 205, 254, 127],
                  [69, 208, 254, 128],
                  [69, 212, 254, 130],
                  [68, 215, 254, 131],
                  [67, 218, 254, 133],
                  [67, 221, 254, 134],
                  [66, 224, 254, 135],
                  [65, 227, 254, 137],
                  [65, 231, 254, 138],
                  [64, 234, 254, 139],
                  [64, 237, 254, 141],
                  [63, 240, 254, 142],
                  [62, 244, 254, 143],
                  [62, 247, 254, 145],
                  [61, 250, 254, 146],
                  [61, 254, 254, 147],
                  [60, 254, 250, 148],
                  [59, 254, 247, 150],
                  [59, 254, 243, 151],
                  [58, 254, 240, 152],
                  [58, 254, 236, 153],
                  [57, 253, 233, 155],
                  [57, 253, 229, 156],
                  [56, 253, 226, 157],
                  [56, 253, 222, 158],
                  [55, 253, 218, 160],
                  [54, 253, 215, 161],
                  [54, 253, 211, 162],
                  [53, 253, 207, 163],
                  [53, 253, 204, 164],
                  [52, 253, 200, 165],
                  [52, 253, 196, 167],
                  [51, 253, 192, 168],
                  [51, 253, 189, 169],
                  [50, 253, 185, 170],
                  [50, 253, 181, 171],
                  [49, 253, 177, 172],
                  [49, 253, 173, 173],
                  [48, 252, 170, 175],
                  [48, 252, 166, 176],
                  [47, 252, 162, 177],
                  [47, 252, 158, 178],
                  [46, 252, 154, 179],
                  [46, 252, 150, 180],
                  [46, 252, 146, 181],
                  [45, 252, 142, 182],
                  [45, 252, 138, 183],
                  [44, 252, 134, 184],
                  [44, 252, 131, 185],
                  [43, 251, 127, 186],
                  [43, 251, 123, 187],
                  [42, 251, 119, 188],
                  [42, 251, 114, 189],
                  [41, 251, 110, 190],
                  [41, 251, 106, 191],
                  [41, 251, 102, 192],
                  [40, 251, 98, 193],
                  [40, 251, 94, 194],
                  [39, 250, 90, 195],
                  [39, 250, 86, 196],
                  [38, 250, 82, 197],
                  [38, 250, 78, 198],
                  [38, 250, 74, 199],
                  [37, 250, 70, 200],
                  [37, 250, 65, 201],
                  [36, 249, 61, 202],
                  [36, 249, 57, 202],
                  [35, 249, 53, 203],
                  [35, 249, 49, 204],
                  [35, 249, 45, 205],
                  [34, 249, 41, 206],
                  [34, 249, 36, 207],
                  [35, 248, 33, 208],
                  [38, 248, 33, 208],
                  [41, 248, 33, 209],
                  [45, 248, 32, 210],
                  [48, 248, 32, 211],
                  [52, 247, 31, 212],
                  [55, 247, 31, 213],
                  [59, 247, 31, 213],
                  [62, 247, 30, 214],
                  [66, 247, 30, 215],
                  [69, 246, 29, 216],
                  [73, 246, 29, 216],
                  [76, 246, 29, 217],
                  [79, 246, 28, 218],
                  [83, 246, 28, 219],
                  [86, 245, 28, 219],
                  [90, 245, 27, 220],
                  [94, 245, 27, 221],
                  [97, 245, 26, 222],
                  [101, 244, 26, 222],
                  [104, 244, 26, 223],
                  [108, 244, 25, 224],
                  [111, 244, 25, 224],
                  [115, 243, 25, 225],
                  [118, 243, 24, 226],
                  [122, 243, 24, 226],
                  [125, 242, 24, 227],
                  [129, 242, 23, 228],
                  [132, 242, 23, 228],
                  [136, 242, 23, 229],
                  [139, 241, 22, 229],
                  [143, 241, 22, 230],
                  [147, 241, 21, 231],
                  [150, 240, 21, 231],
                  [154, 240, 21, 232],
                  [157, 240, 20, 232],
                  [161, 239, 20, 233],
                  [164, 239, 20, 234],
                  [168, 239, 19, 234],
                  [171, 238, 19, 235],
                  [175, 238, 19, 235],
                  [178, 238, 18, 236],
                  [182, 237, 18, 236],
                  [185, 237, 18, 237],
                  [189, 236, 17, 237],
                  [192, 236, 17, 238],
                  [196, 236, 17, 238],
                  [199, 235, 17, 239],
                  [203, 235, 16, 239],
                  [206, 234, 16, 240],
                  [210, 234, 16, 240],
                  [213, 234, 15, 241],
                  [216, 233, 15, 241],
                  [220, 233, 15, 242],
                  [223, 232, 14, 242],
                  [227, 232, 14, 242],
                  [230, 231, 14, 243],
                  [231, 228, 13, 243],
                  [230, 224, 13, 244],
                  [230, 220, 13, 244],
                  [229, 215, 13, 244],
                  [229, 211, 12, 245],
                  [228, 207, 12, 245],
                  [228, 202, 12, 246],
                  [227, 198, 11, 246],
                  [227, 194, 11, 246],
                  [226, 190, 11, 247],
                  [226, 185, 10, 247],
                  [225, 181, 10, 247],
                  [225, 177, 10, 248],
                  [224, 172, 10, 248],
                  [223, 168, 9, 248],
                  [223, 164, 9, 248],
                  [222, 159, 9, 249],
                  [222, 155, 9, 249],
                  [221, 151, 8, 249],
                  [220, 147, 8, 250],
                  [220, 142, 8, 250],
                  [219, 138, 7, 250],
                  [219, 134, 7, 250],
                  [218, 130, 7, 251],
                  [217, 126, 7, 251],
                  [217, 121, 6, 251],
                  [216, 117, 6, 251],
                  [215, 113, 6, 252],
                  [214, 109, 6, 252],
                  [214, 105, 5, 252],
                  [213, 101, 5, 252],
                  [212, 96, 5, 252],
                  [212, 92, 5, 252],
                  [211, 88, 4, 253],
                  [210, 84, 4, 253],
                  [209, 80, 4, 253],
                  [209, 76, 4, 253],
                  [208, 72, 3, 253],
                  [207, 68, 3, 253],
                  [206, 64, 3, 253],
                  [205, 60, 3, 254],
                  [204, 56, 3, 254],
                  [204, 52, 2, 254],
                  [203, 48, 2, 254],
                  [202, 44, 2, 254],
                  [201, 40, 2, 254],
                  [200, 37, 1, 254],
                  [199, 33, 1, 254],
                  [198, 29, 1, 254],
                  [197, 25, 1, 254],
                  [197, 21, 1, 254],
                  [196, 18, 0, 254],
                  [195, 14, 0, 254],
                  [194, 10, 0, 254],
                  [193, 7, 0, 254],
                  [192, 3, 0, 254],
                  [191, 0, 0, 255],
                ]);
          }),
          (t.prototype.incrLine = function () {
            this.nextLine++, this.nextLine >= this.lines && (this.nextLine = 0);
          }),
          (t.prototype.updateWaterfall = function () {
            var t = this.getDataOrganized();
            this.horizontalNewLine();
            var e = this.mode;
            if (
              (((!e && this.heartMode) || "HEART" === e) &&
                this.drawSoundLine(t),
              this.running)
            ) {
              this.sgTime += this.interval;
              var i = Date.now() - this.sgStartTime - this.sgTime,
                o = this;
              this.timerID = setTimeout(function () {
                o.updateWaterfall();
              }, this.interval - i);
            }
          }),
          (t.prototype.getDataOrganized = function () {
            this.spectogramDrawer.analyserNode.getFloatFrequencyData(
              this.spectogramDrawer.floatFreqData
            );
            var t = this.spectogramDrawer.getMaxMinPosition();
            return (
              this.spectogramDrawer.doGainAdjust(),
              this.spectogramDrawer.convertToByteFrequencyData(),
              this.spectogramDrawer.adjustVerticalScaleByteBuffer(),
              t
            );
          }),
          (t.prototype.drawSoundLine = function (t) {
            var e = this.spectogramDrawer.targetHeight / 200,
              i = this.spectogramDrawer.targetWidth / 3,
              o = this.spectogramDrawer.targetHeight / (3 * e),
              a = o - t[0] * i,
              n = o - t[1] * i;
            n - a < 1 && (n = a + 1);
            var r = this.offScreenCtx.globalCompositeOperation;
            (this.offScreenCtx.globalCompositeOperation = "source-over"),
              this.offScreenCtx.beginPath(),
              this.offScreenCtx.translate(0.5, 0),
              this.offScreenCtx.moveTo(1, a),
              this.offScreenCtx.lineTo(1, n),
              this.offScreenCtx.stroke(),
              (this.offScreenCtx.globalCompositeOperation = r),
              this.offScreenCtx.resetTransform();
          }),
          (t.prototype.sgSetLineRate = function (t) {
            isNaN(t) || t < 0
              ? console.error("invalid line rate [0 <= lineRate]")
              : 0 === t
              ? (this.lineRate = 0)
              : ((this.lineRate = t), (this.interval = 1e3 / this.lineRate));
          }),
          (t.prototype.setProperty = function (t, e) {
            if ("string" == typeof t && void 0 !== e)
              switch (t.toLowerCase()) {
                case "linerate":
                  this.sgSetLineRate(e);
                  break;
                case "startbin":
                  !isNaN(e) && e > 0 && (this.startOfs = e);
                  break;
                case "onscreenparentid":
                  "string" == typeof e &&
                    document.getElementById(e) &&
                    (this.demoCvsId = e);
                  break;
                case "colormap":
                  if (
                    Array.isArray(e) &&
                    Array.isArray(e[0]) &&
                    4 == e[0].length &&
                    ((this.colMap = e), this.colMap.length < 256)
                  )
                    for (var i = this.colMap.length; i < 256; i++)
                      this.colMap[i] = this.colMap[this.colMap.length - 1];
              }
          }),
          (t.prototype.horizontalNewLine = function () {
            var t;
            (t =
              this.ipBufAry[0].constructor !== Uint8Array
                ? Uint8ClampedArray.from(this.ipBufAry[0])
                : this.ipBufAry[0]),
              (this.offScreenCtx.globalCompositeOperation = "copy"),
              (this.offScreenCtx.imageSmoothingEnabled = !1),
              this.offScreenCtx.drawImage(this.offScreenCtx.canvas, 1, 0),
              (this.offScreenCtx.globalCompositeOperation = "source-over");
            for (
              var e = this.lines - 152, i = void 0, o = void 0, a = 0;
              a < this.lines;
              a++
            )
              (i = t[a - e] || 0),
                (o = this.colMap[i]),
                this.addReplaceColorMap(o, a, 0);
            this.offScreenCtx.putImageData(
              this.vertLineImgData,
              1,
              this.nextLine
            );
          }),
          (t.prototype.addReplaceColorMap = function (t, e, i) {
            var o = 4 * (this.lines - 1 - e) + i;
            (this.vertLineBuf8[o] = t[0]),
              (this.vertLineBuf8[o + 1] = t[1]),
              (this.vertLineBuf8[o + 2] = t[2]);
            var a = this.mode;
            this.vertLineBuf8[o + 3] = "LUNG" === a ? 85 : t[3];
          }),
          (t.prototype.clear = function () {
            this.offScreenCtx.putImageData(this.clearImgData, 0, 0),
              console.log(this.clearImgData),
              (this.colMap = []);
          }),
          (t.prototype.start = function () {
            (this.sgStartTime = Date.now()),
              (this.sgTime = 0),
              (this.running = !0),
              this.updateWaterfall();
          }),
          (t.prototype.resume = function () {
            console.log(this.sgTime),
              (this.running = !0),
              this.updateWaterfall();
          }),
          (t.prototype.pause = function () {
            (this.running = !1),
              this.timerID && clearTimeout(this.timerID),
              (this.nextLine = 0);
          }),
          (t.prototype.stop = function () {
            (this.running = !1),
              this.timerID && clearTimeout(this.timerID),
              (this.nextLine = 0);
          }),
          t
        );
      })(),
      r = function (t, e, i, o) {
        return new (i || (i = Promise))(function (a, n) {
          function r(t) {
            try {
              c(o.next(t));
            } catch (t) {
              n(t);
            }
          }
          function s(t) {
            try {
              c(o.throw(t));
            } catch (t) {
              n(t);
            }
          }
          function c(t) {
            var e;
            t.done
              ? a(t.value)
              : ((e = t.value),
                e instanceof i
                  ? e
                  : new i(function (t) {
                      t(e);
                    })).then(r, s);
          }
          c((o = o.apply(t, e || [])).next());
        });
      },
      s = function (t, e) {
        var i,
          o,
          a,
          n,
          r = {
            label: 0,
            sent: function () {
              if (1 & a[0]) throw a[1];
              return a[1];
            },
            trys: [],
            ops: [],
          };
        return (
          (n = { next: s(0), throw: s(1), return: s(2) }),
          "function" == typeof Symbol &&
            (n[Symbol.iterator] = function () {
              return this;
            }),
          n
        );
        function s(n) {
          return function (s) {
            return (function (n) {
              if (i) throw new TypeError("Generator is already executing.");
              for (; r; )
                try {
                  if (
                    ((i = 1),
                    o &&
                      (a =
                        2 & n[0]
                          ? o.return
                          : n[0]
                          ? o.throw || ((a = o.return) && a.call(o), 0)
                          : o.next) &&
                      !(a = a.call(o, n[1])).done)
                  )
                    return a;
                  switch (((o = 0), a && (n = [2 & n[0], a.value]), n[0])) {
                    case 0:
                    case 1:
                      a = n;
                      break;
                    case 4:
                      return r.label++, { value: n[1], done: !1 };
                    case 5:
                      r.label++, (o = n[1]), (n = [0]);
                      continue;
                    case 7:
                      (n = r.ops.pop()), r.trys.pop();
                      continue;
                    default:
                      if (
                        !(
                          (a = (a = r.trys).length > 0 && a[a.length - 1]) ||
                          (6 !== n[0] && 2 !== n[0])
                        )
                      ) {
                        r = 0;
                        continue;
                      }
                      if (3 === n[0] && (!a || (n[1] > a[0] && n[1] < a[3]))) {
                        r.label = n[1];
                        break;
                      }
                      if (6 === n[0] && r.label < a[1]) {
                        (r.label = a[1]), (a = n);
                        break;
                      }
                      if (a && r.label < a[2]) {
                        (r.label = a[2]), r.ops.push(n);
                        break;
                      }
                      a[2] && r.ops.pop(), r.trys.pop();
                      continue;
                  }
                  n = e.call(t, r);
                } catch (t) {
                  (n = [6, t]), (o = 0);
                } finally {
                  i = a = 0;
                }
              if (5 & n[0]) throw n[1];
              return { value: n[0] ? n[1] : void 0, done: !0 };
            })([n, s]);
          };
        }
      },
      c = (function () {
        function t(t, e) {
          var i = this;
          (this.lungGain = 5),
            (this.heartGain = 1),
            (this.mode = "HEART"),
            (this.lowAudioFlag = 0),
            (this.filterFunctions = {}),
            (this.decodedPackets = []),
            (this.kAudioFrequencyExact = 44100),
            (this.importObject = {
              imports: {
                imported_func: function (t) {
                  console.log(t);
                },
                wasi_unstable: function () {},
              },
            }),
            (this.endpoint = "https://api.stethio.com"),
            (this.audioInput = function (t) {
              if (((i.totalBytesIn += t.byteLength), null == i.decoder))
                return (
                  (i.decoderOperational = !1),
                  (i.packetsToDecode = []),
                  void i.loadOpusDecoder().then(
                    function () {
                      i.decoderOperational = !0;
                    },
                    function (t) {
                      console.log("decoder.decode error");
                    }
                  )
                );
              var e = { data: t };
              i.packetsToDecode.push(e),
                (!i.decoderOperational && i.packetsToDecode.length < 3) ||
                  i.decodePackets();
            }),
            (this.testAudioInput = function (t) {
              var e = "HEART" == i.mode;
              i.socketWorkletNode &&
                i.socketWorkletNode.port.postMessage({
                  type: "samples",
                  samples: t,
                  heartMode: e,
                  gain: e ? i.heartGain : i.lungGain,
                  isAutoGainEnabled: i.isAutoGainEnabled,
                  isFilterEnabled: i.isFilterEnabled,
                });
            }),
            (this.handleWorkletProcessorMessage = function (t) {
              console.log("At handle events: ", t.data.outputs),
                i.socketWorkletNode.port.postMessage({
                  type: "live",
                  outputs: t.data.outputs,
                });
            }),
            (this.old_handleWorkletProcessorMessage = function (t) {
              if (
                (console.log("handleWorkletProcessorMessage: ", t),
                1 !== i.feedbackGain)
              )
                for (var e = 0; e < t.data.samples.length; e++)
                  t.data.samples[e] = t.data.samples[e] * i.feedbackGain;
              i.buffersToEncode.push(t.data.samples),
                i.queueBufferForEncodingAndSend();
            }),
            (this.audioContext = null),
            (this.micStream = null),
            (this.micSourceNode = null),
            (this.encoder = null),
            (this.decoder = null),
            (this.socketWorkletNode = null),
            (this.totalBytesIn = 0),
            (this.totalSamplesIn = 0),
            (this.totalBytesSent = 0),
            (this.decoderOperational = !1),
            (this.packetsToDecode = []),
            (this.decodingPackets = !1),
            (this.encodingBuffers = !1),
            (this.buffersToEncode = []),
            (this.analyser = null),
            (this.analyserBufferSize = 128),
            (this.analyserData = null),
            (this.feedbackGain = 1),
            (this.refreshTimer = 0),
            (this.divID = t),
            (this.lowAudioFlag = 0),
            (this.isFilterEnabled = !0),
            (this.isAutoGainEnabled = !0),
            e &&
              ("HEART" == e.mode
                ? ((this.heartGain = +e.gain > 0 && +e.gain <= 3 ? +e.gain : 1),
                  (this.mode = "HEART"))
                : "LUNG" == e.mode &&
                  ((this.lungGain = +e.gain > 0 && +e.gain <= 20 ? +e.gain : 5),
                  (this.mode = "LUNG")));
        }
        return (
          (t.prototype.initAudioEngine = function (e, i, o) {
            return r(this, void 0, void 0, function () {
              var a, n;
              return s(this, function (r) {
                switch (r.label) {
                  case 0:
                    return (
                      r.trys.push([0, 3, , 4]),
                      [
                        4,
                        fetch(
                          "".concat(
                            this.endpoint,
                            "/api/sdk/key/verify/?encrypt=false"
                          ),
                          {
                            method: "POST",
                            redirect: "follow",
                            referrerPolicy: "no-referrer",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                              data: { key: i, device_id: "" },
                            }),
                          }
                        ),
                      ]
                    );
                  case 1:
                    return [4, r.sent().json()];
                  case 2:
                    return (a = r.sent()).hasOwnProperty("is_active") &&
                      1 == a.is_active
                      ? (void 0 === this.instance &&
                          (this.instance = new t(e, o)),
                        console.log(
                          "StethIO Spectrogram Initialized Successfully!"
                        ),
                        [2, this.instance])
                      : (console.log(
                          "SDK Key Invalid. StethIO Spectrogram Initialized Failed!"
                        ),
                        [2]);
                  case 3:
                    return (
                      (n = r.sent()),
                      console.log(n),
                      console.log(
                        "SDK Key Invalid. StethIO Spectrogram Initialized Failed!"
                      ),
                      [2]
                    );
                  case 4:
                    return [2];
                }
              });
            });
          }),
          (t.prototype.setAutoGainFlag = function (t) {
            return r(this, void 0, void 0, function () {
              return s(this, function (e) {
                return (this.isAutoGainEnabled = t), [2];
              });
            });
          }),
          (t.prototype.setFilterFlag = function (t) {
            return r(this, void 0, void 0, function () {
              return s(this, function (e) {
                return (this.isFilterEnabled = t), [2];
              });
            });
          }),
          (t.prototype.startIt = function (t) {
            return r(this, void 0, void 0, function () {
              return s(this, function (e) {
                switch (e.label) {
                  case 0:
                    return (
                      (this.audioContext = new AudioContext({
                        sampleRate: 44100,
                      })),
                      (this.biquadFilter =
                        this.audioContext.createBiquadFilter()),
                      (this.distortion = this.audioContext.createWaveShaper()),
                      (this.gainNode = this.audioContext.createGain()),
                      (this.convolver = this.audioContext.createConvolver()),
                      [
                        4,
                        this.audioContext.audioWorklet.addModule(
                          "https://cdn.jsdelivr.net/gh/StratoScientific/StethIO-SDK-Web/assets/steth-worklet-processor.js",
                          { credentials: "omit" }
                        ),
                      ]
                    );
                  case 1:
                    return (
                      e.sent(),
                      console.log("startIt start"),
                      console.log("startIt"),
                      [2, this.onModuleAdded(t)]
                    );
                }
              });
            });
          }),
          (t.prototype.pause = function () {
            this.spectrogramDrawer.haltDisplay(),
              this.socketWorkletNode.port.postMessage({
                type: "setState",
                state: "kPause",
                filterFunctions: JSON.stringify(this.filterFunctions),
                newAudioFilter: this.newAudioFilter,
              });
          }),
          (t.prototype.resume = function () {
            this.spectrogramDrawer.resumeDisplay(),
              this.socketWorkletNode.port.postMessage({
                type: "setState",
                state: "kRecordRemote",
                filterFunctions: JSON.stringify(this.filterFunctions),
                newAudioFilter: this.newAudioFilter,
              });
          }),
          (t.prototype.close = function () {
            if (
              (this.spectrogramDrawer && this.spectrogramDrawer.haltDisplay(),
              this.micStream)
            )
              for (var t = 0, e = this.micStream.getTracks(); t < e.length; t++)
                e[t].stop();
            this.audioContext &&
              "closed" != this.audioContext.state &&
              (this.audioContext.close(), (this.audioContext = null)),
              this.refreshTimer &&
                (clearInterval(this.refreshTimer), (this.refreshTimer = null));
          }),
          (t.prototype.stop = function () {
            this.spectrogramDrawer &&
              (this.spectrogramDrawer.stopDisplay(),
              this.socketWorkletNode.port.postMessage({
                type: "setState",
                state: "kPause",
                filterFunctions: JSON.stringify(this.filterFunctions),
                newAudioFilter: this.newAudioFilter,
              }));
          }),
          (t.prototype.volumeSet = function (t) {
            this.socketWorkletNode.port.postMessage({
              type: "volume",
              volume: t,
              heartMode: "HEART" == this.mode,
            });
          }),
          (t.prototype.playbackSpeedChange = function (t) {
            this.spectrogramDrawer &&
              this.spectrogramDrawer.alterPlayBackSpeed(100 * t);
          }),
          (t.prototype.onModuleAdded = function (t) {
            return r(this, void 0, void 0, function () {
              var e, i, o, n;
              return s(this, function (r) {
                switch (r.label) {
                  case 0:
                    return (
                      (e = "HEART" == this.mode),
                      (i = {
                        audio: {
                          echoCancellation: !1,
                          googEchoCancellation: { exact: !1 },
                          channelCount: 2,
                          autoGainControl: !1,
                          noiseSuppression: !1,
                          sampleRate: 44100,
                        },
                      }),
                      [4, this.loadOpusEncoder()]
                    );
                  case 1:
                    return (
                      r.sent(),
                      (o = this),
                      [4, navigator.mediaDevices.getUserMedia(i)]
                    );
                  case 2:
                    return (
                      (o.micStream = r.sent()),
                      (this.micSourceNode =
                        this.audioContext.createMediaStreamSource(
                          this.micStream
                        )),
                      (this.socketWorkletNode = new AudioWorkletNode(
                        this.audioContext,
                        "socket-worklet"
                      )),
                      this.socketWorkletNode.connect(
                        this.audioContext.destination
                      ),
                      (this.spectrogramDrawer = new a(
                        this.audioContext,
                        this.divID,
                        e
                      )),
                      this.spectrogramDrawer.beginDisplay(),
                      this.socketWorkletNode.connect(
                        this.spectrogramDrawer.analyserNode
                      ),
                      (n = "kPause"),
                      t && (n = "kRecordMic"),
                      console.log("moduleloaded", t, this.socketWorkletNode, n),
                      [2, !0]
                    );
                }
              });
            });
          }),
          (t.prototype.connectHeartBiquad = function (t) {
            if ((void 0 === t && (t = !0), t))
              (this.biquadFilter.type = "lowpass"),
                (this.biquadFilter.frequency.value = 250),
                this.micSourceNode.connect(this.biquadFilter);
            else {
              (this.gainNode = this.audioContext.createGain()),
                (this.gainNode.gain.value = 40),
                (this.biquadFilter.type = "highpass"),
                (this.biquadFilter.frequency.value = 15),
                (this.biquadFilter.Q.value = 0.707107),
                this.gainNode.connect(this.biquadFilter);
              var e = this.audioContext.createBiquadFilter(),
                i = this.audioContext.createBiquadFilter(),
                o = this.audioContext.createBiquadFilter(),
                a = this.audioContext.createBiquadFilter(),
                n = this.audioContext.createBiquadFilter(),
                r = this.audioContext.createBiquadFilter(),
                s = this.audioContext.createBiquadFilter(),
                c = this.audioContext.createBiquadFilter();
              (e.type = "peaking"),
                (e.frequency.value = 40),
                (e.Q.value = 0.7071),
                (e.gain.value = 6),
                this.biquadFilter.connect(e),
                (i.type = "lowpass"),
                (i.frequency.value = 200),
                (i.Q.value = 0.707107),
                e.connect(i),
                (o.type = "lowpass"),
                (o.frequency.value = 200),
                (o.Q.value = 1.306),
                i.connect(o),
                (a.type = "lowpass"),
                (a.frequency.value = 200),
                (a.Q.value = 0.541),
                o.connect(a),
                (n.type = "highpass"),
                (n.frequency.value = 20),
                (n.Q.value = 0.5),
                a.connect(n),
                (r.type = "peaking"),
                (r.frequency.value = 160),
                (r.Q.value = 1),
                (r.gain.value = 2),
                n.connect(r),
                (s.type = "peaking"),
                (s.frequency.value = 600),
                (s.Q.value = 2),
                (s.gain.value = -3),
                r.connect(s),
                (c.type = "peaking"),
                (c.frequency.value = 2100),
                (c.Q.value = 4.5),
                (c.gain.value = 12),
                s.connect(c),
                c.connect(this.spectrogramDrawer.analyserNode);
            }
          }),
          (t.prototype.connectLungBiquad = function (t) {
            if ((void 0 === t && (t = !0), t))
              (this.gainNode = this.audioContext.createGain()),
                (this.gainNode.gain.value = 2),
                this.micSourceNode.connect(this.gainNode),
                (this.biquadFilter.type = "lowpass"),
                (this.biquadFilter.frequency.value = 400),
                (this.biquadFilter.Q.value = 0.7071),
                this.gainNode.connect(this.biquadFilter),
                this.biquadFilter.connect(this.audioContext.destination);
            else {
              var e = new AudioWorkletNode(
                this.audioContext,
                "lung-noise-gate"
              );
              new AudioWorkletNode(this.audioContext, "lung-auto-gain"),
                (this.gainNode = this.audioContext.createGain()),
                (this.gainNode.gain.value = 60),
                e.connect(this.gainNode),
                (this.biquadFilter.type = "highpass"),
                (this.biquadFilter.frequency.value = 80),
                (this.biquadFilter.Q.value = 0.707107),
                this.gainNode.connect(this.biquadFilter);
              var i = this.audioContext.createBiquadFilter(),
                o = this.audioContext.createBiquadFilter(),
                a = this.audioContext.createBiquadFilter(),
                n = this.audioContext.createBiquadFilter(),
                r = this.audioContext.createBiquadFilter(),
                s = this.audioContext.createBiquadFilter(),
                c = this.audioContext.createBiquadFilter();
              (i.type = "lowpass"),
                (i.frequency.value = 400),
                (i.Q.value = 0.707107),
                this.biquadFilter.connect(i),
                (o.type = "lowpass"),
                (o.frequency.value = 1500),
                (o.Q.value = 1.306),
                i.connect(o),
                (a.type = "lowpass"),
                (a.frequency.value = 1500),
                (a.Q.value = 0.541),
                o.connect(a),
                (n.type = "highpass"),
                (n.frequency.value = 20),
                (n.Q.value = 0.5),
                a.connect(n),
                (r.type = "peaking"),
                (r.frequency.value = 160),
                (r.Q.value = 1),
                (r.gain.value = 2),
                n.connect(r),
                (s.type = "peaking"),
                (s.frequency.value = 600),
                (s.Q.value = 2),
                (s.gain.value = -3),
                r.connect(s),
                (c.type = "peaking"),
                (c.frequency.value = 2100),
                (c.Q.value = 4.5),
                (c.gain.value = 12),
                s.connect(c),
                c.connect(this.spectrogramDrawer.analyserNode);
            }
          }),
          (t.prototype.workerCros = function (t) {
            var e = "importScripts('" + t + "');";
            return URL.createObjectURL(new Blob([e]));
          }),
          (t.prototype.loadOpusEncoder = function () {
            return r(this, void 0, void 0, function () {
              var t, e;
              return s(this, function (i) {
                return (
                  (t = this.workerCros(
                    new URL(
                      "https://cdn.jsdelivr.net/gh/StratoScientific/StethIO-SDK-Web/assets/opus_encoder.js",
                      window.location + ""
                    ).href
                  )),
                  (this.encoder = new o(t)),
                  console.log(this.encoder),
                  (e = {
                    sampling_rate: 44100,
                    num_of_channels: 1,
                    params: {
                      application: 2049,
                      sampling_rate: 48e3,
                      frame_duration: 20,
                    },
                  }),
                  [2, this.encoder.setup(e)]
                );
              });
            });
          }),
          (t.prototype.loadOpusDecoder = function () {
            return r(this, void 0, void 0, function () {
              var t;
              return s(this, function (e) {
                return (
                  (t = this.workerCros(
                    new URL(
                      "https://cdn.jsdelivr.net/gh/StratoScientific/StethIO-SDK-Web/assets/opus_decoder.js",
                      window.location + ""
                    ).href
                  )),
                  (this.decoder = new i(t)),
                  (this.decoderOperational = !0),
                  [
                    2,
                    this.decoder.setup(
                      { channels: 1, sampling_rate: 44100 },
                      {}
                    ),
                  ]
                );
              });
            });
          }),
          (t.prototype.queueBufferForEncodingAndSend = function () {
            return r(this, void 0, void 0, function () {
              var t, e, i, o, a;
              return s(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (this.encodingBuffers) return [2];
                    if (0 === this.buffersToEncode.length) return [2];
                    (this.encodingBuffers = !0),
                      (t = this.buffersToEncode.shift()),
                      (e = { timestamp: 0, samples: t, transferable: !0 }),
                      (n.label = 1);
                  case 1:
                    return (
                      n.trys.push([1, 3, , 4]), [4, this.encoder.encode(e)]
                    );
                  case 2:
                    for (i = n.sent(), o = 0; o < i.length; ++o)
                      this.totalBytesSent += i[o].data.byteLength;
                    return (
                      (this.encodingBuffers = !1),
                      this.queueBufferForEncodingAndSend(),
                      [3, 4]
                    );
                  case 3:
                    return (
                      (a = n.sent()),
                      console.log("encoder.encoder error", a),
                      [3, 4]
                    );
                  case 4:
                    return [2];
                }
              });
            });
          }),
          (t.prototype.decodePackets = function () {
            var t = this,
              e = "HEART" == this.mode;
            if (!this.decodingPackets && 0 !== this.packetsToDecode.length) {
              this.decodingPackets = !0;
              var i = this.packetsToDecode.shift();
              this.decoder
                .decode(i)
                .then(
                  function (i) {
                    i.samples &&
                      ((t.totalSamplesIn += i.samples.length),
                      t.decodedPackets.push(i.samples),
                      t.socketWorkletNode &&
                        (console.log(i),
                        t.socketWorkletNode.port.postMessage({
                          type: "samples",
                          samples: i.samples,
                          heartMode: e,
                          gain: e ? t.heartGain : t.lungGain,
                        }))),
                      (t.decodingPackets = !1),
                      t.decodePackets();
                  },
                  function (t) {
                    console.log("worklet decoder.decode error", t);
                  }
                )
                .catch(function (t) {
                  return console.log("Unable to decode", t);
                });
            }
          }),
          (t.prototype.setUpFeedbackAnalyser = function () {
            var t = this;
            (this.analyser = this.audioContext.createAnalyser()),
              (this.analyser.fftSize = 256),
              (this.analyserData = new Float32Array(
                this.analyser.frequencyBinCount
              )),
              (this.refreshTimer = setInterval(function () {
                return t.refreshAnalyserData();
              }, 50)),
              this.micSourceNode.connect(this.analyser);
          }),
          (t.prototype.refreshAnalyserData = function () {
            this.analyser.getFloatFrequencyData(this.analyserData);
            var t,
              e = (100 / 24e3) * this.analyser.frequencyBinCount,
              i = (2e3 / 24e3) * this.analyser.frequencyBinCount,
              o = 0,
              a = 0,
              n = 0,
              r = 0,
              s = 0,
              c = 0;
            for (t = 0; t < this.analyser.frequencyBinCount; t++)
              t < e
                ? ((o += this.analyserData[t]), a++)
                : t < i
                ? ((n += this.analyserData[t]), r++)
                : ((s += this.analyserData[t]), c++);
            (o /= a),
              (n /= r),
              (s /= c),
              (this.feedbackGain = 1),
              1.3 * n < s &&
                ((this.feedbackGain = s / (1.3 * n)),
                console.log("feedback? gain is now: " + this.feedbackGain)),
              console.log(
                "power low: " + o + "   power mid: " + n + "   power hi: " + s
              );
          }),
          (t.prototype.setInputEnabled = function (t) {
            this.micStream && (this.micStream.getAudioTracks()[0].enabled = t);
          }),
          (t.prototype.setAudioBuffer = function (t) {
            var e = "HEART" == this.mode,
              i = t.getChannelData(0);
            this.socketWorkletNode.port.postMessage({
              type: "setSamples",
              samples: i,
              heartMode: e,
              gain: e ? this.heartGain : this.lungGain,
            });
          }),
          (t.prototype.addAudioSamples = function (t) {
            this.socketWorkletNode.port.postMessage({
              type: "samples",
              samples: t,
              filterFunctions: JSON.stringify(this.filterFunctions),
              newAudioFilter: this.newAudioFilter,
            });
          }),
          (t.prototype.resampleAudio = function (t) {
            return r(this, void 0, void 0, function () {
              return s(this, function (t) {
                return [2];
              });
            });
          }),
          (t.prototype.parseBiquadFilter = function (t) {
            var e = this;
            void 0 === t && (t = "heart"),
              h &&
                h.iphone7.forEach(function (i) {
                  i.name === t &&
                    i.filter &&
                    i.filter.forEach(function (t) {
                      e.addFilter(t);
                    });
                });
          }),
          (t.prototype.addFilter = function (t) {
            var e = 0,
              i = 0,
              o = 0,
              a = 0,
              n = 0,
              r = 0,
              s = 0,
              c = 0,
              l = 0,
              h = 0,
              u = [0, 0, 0, 0, 0],
              d = !1,
              f = t.type;
            if ("peak" == f) {
              var p = t.freq || 0;
              if (0 == (m = t.q || 0)) {
                var g = t.width || 0;
                g < 0.001 && (g = 0.001),
                  (m = this.filterFunctions.calculateQFromOctaveWidth(g));
              }
              var y = t.gain || 0;
              this.filterFunctions.calculateBiquadPeak(
                p,
                this.kAudioFrequencyExact,
                m,
                y,
                e,
                i,
                o,
                a,
                n
              ),
                (d = !0);
            }
            if ("lowpass2" == f) {
              p = t.freq || 0;
              var m = t.q || 0;
              this.filterFunctions.calculateLP2(
                p,
                this.kAudioFrequencyExact,
                m,
                u
              ),
                (e = u[0]),
                (i = u[1]),
                (o = u[2]),
                (a = u[3]),
                (n = u[4]),
                (d = !0);
            }
            "highpass2" == f &&
              ((p = t.freq || 0),
              (m = t.q || 0),
              this.filterFunctions.calculateHP2(
                p,
                this.kAudioFrequencyExact,
                m,
                u
              ),
              (e = u[0]),
              (i = u[1]),
              (o = u[2]),
              (a = u[3]),
              (n = u[4]),
              (d = !0)),
              "Butterworth4a" == f &&
                ((p = t.freq || 0),
                this.filterFunctions.calculateBW4Section(
                  p,
                  this.kAudioFrequencyExact,
                  0,
                  u
                ),
                (e = u[0]),
                (i = u[1]),
                (o = u[2]),
                (a = u[3]),
                (n = u[4]),
                (d = !0)),
              "Butterworth4b" == f &&
                ((p = t.freq || 0),
                this.filterFunctions.calculateBW4Section(
                  p,
                  this.kAudioFrequencyExact,
                  1,
                  u
                ),
                (e = u[0]),
                (i = u[1]),
                (o = u[2]),
                (a = u[3]),
                (n = u[4]),
                (d = !0)),
              "bandpass2" == f &&
                ((p = t.freq || 0),
                (m = t.q || 0),
                this.filterFunctions.calculateBP2(
                  p,
                  this.kAudioFrequencyExact,
                  m,
                  u
                ),
                (e = u[0]),
                (i = u[1]),
                (o = u[2]),
                (a = u[3]),
                (n = u[4]),
                (d = !0)),
              "raw" == f &&
                ((e = t.a0 || 0),
                (i = t.a1 || 0),
                (o = t.a2 || 0),
                (a = t.b1 || 0),
                (n = t.b2 || 0),
                (d = !0)),
              null != t.a0 &&
                ((r = t.a0 || 0),
                (s = t.a1 || 0),
                (c = t.a2 || 0),
                (l = t.b1 || 0),
                (h = t.b2 || 0),
                (Math.abs(e - r) > 1e-7 ||
                  Math.abs(i - s) > 1e-7 ||
                  Math.abs(o - c) > 1e-7 ||
                  Math.abs(a - l) > 1e-7 ||
                  Math.abs(n - h) > 1e-7) &&
                  console.log("Error designing ".concat(t, " filter"))),
              d
                ? this.filterFunctions.glsteth_filter_addBiquad(
                    this.newAudioFilter,
                    e,
                    i,
                    o,
                    a,
                    n
                  )
                : console.log("Failed to decode ".concat(t, " filter"));
          }),
          t
        );
      })();
    const l = c;
    var h = {
      note: "Filter updates by Ray Miller with Puck EQ.",
      date: "2020-04-01T13:21:58Z",
      default: "iphone7",
      devices: ["iphone7"],
      iphone7: [
        {
          filter: [
            {
              type: "highpass2",
              freq: 15,
              q: 0.707107,
              note: "HP 15 Hz",
              a0: 0.9984899566,
              a1: -1.9969799132,
              a2: 0.9984899566,
              b1: -1.9969776329,
              b2: 0.9969821934,
            },
            {
              type: "peak",
              note: "earlevel peak filter",
              freq: 40,
              q: 0.7071,
              gain: 6,
            },
            {
              type: "lowpass2",
              freq: 200,
              q: 0.707107,
              note: "LP 200Hz fs 44100",
              a0: 0.0001989714,
              a1: 0.0003979428,
              a2: 0.0001989714,
              b1: -1.9597070338,
              b2: 0.9605029194,
            },
            {
              type: "Butterworth4a",
              freq: 250,
              note: "BW4A 250Hz fs 44100",
              a0: 0.0003128802,
              a1: 0.0006257604,
              a2: 0.0003128802,
              b1: -1.9718591139,
              b2: 0.9731106348,
            },
            {
              type: "Butterworth4b",
              freq: 250,
              note: "BW4B 250Hz fs 44100",
              a0: 0.0003070422,
              a1: 0.0006140845,
              a2: 0.0003070422,
              b1: -1.9350664333,
              b2: 0.9362946022,
            },
            { type: "highpass2", freq: 20, q: 0.5, note: "HP 20 Hz" },
            { type: "peak", note: "peak filter", freq: 160, q: 1, gain: 2 },
            { type: "peak", note: "peak filter", freq: 600, q: 2, gain: -3 },
            { type: "peak", note: "peak filter", freq: 2100, q: 4.5, gain: 12 },
          ],
          note: "",
          name: "heart",
        },
        {
          filter: [
            {
              type: "highpass2",
              freq: 80,
              q: 0.707107,
              note: "HPF at 80 Hz, fs 44100",
              a0: 0.9919727398,
              a1: -1.9839454796,
              a2: 0.9919727398,
              b1: -1.9838810417,
              b2: 0.9840099175,
            },
            {
              type: "lowpass2",
              freq: 400,
              q: 0.707107,
              note: "LPF at 400 Hz, fs 44100",
              a0: 0.0007803263,
              a1: 0.0015606526,
              a2: 0.0007803263,
              b1: -1.9194445715,
              b2: 0.9225658767,
            },
            {
              type: "Butterworth4a",
              freq: 1500,
              note: "BW4A 1500 Hz, fs 44100",
              a0: 0.0105210738,
              a1: 0.0210421475,
              a2: 0.0105210738,
              b1: -1.807774542,
              b2: 0.8498588371,
            },
            {
              type: "Butterworth4b",
              freq: 1500,
              note: "BW4B, 1500 Hz, fs 44100",
              a0: 0.0095112988,
              a1: 0.0190225976,
              a2: 0.0095112988,
              b1: -1.6342708171,
              b2: 0.6723160123,
            },
            { type: "highpass2", freq: 20, q: 0.5, note: "HP 20 Hz" },
            { type: "peak", note: "peak filter", freq: 160, q: 1, gain: 2 },
            { type: "peak", note: "peak filter", freq: 600, q: 2, gain: -3 },
            { type: "peak", note: "peak filter", freq: 2100, q: 4.5, gain: 12 },
          ],
          note: "",
          name: "lungs",
        },
      ],
    };
    return (window.AudioEngine = c), e;
  })();
});
